// The reply-categorization taxonomy, mirrored from the backend
// (`src/services/outreach/reply-parser.taxonomy.ts`). Used to render category
// pills and to drive the relabel picker in the reply inbox.

export const REPLY_CATEGORIES = [
  'scheduling_delay_client_side',
  'scheduling_delay_coach_side',
  'hours_just_logged',
  'will_log_by_date',
  'engagement_complete_should_close',
  'client_unresponsive',
  'needs_extension',
  'paused_on_hold',
  'billing_finance_question',
  'escalate_to_ariel',
  'no_action_fyi',
  'ambiguous_needs_human',
] as const;

export type ReplyCategory = (typeof REPLY_CATEGORIES)[number];

export const REPLY_CATEGORY_LABELS: Record<string, string> = {
  scheduling_delay_client_side: 'Client-side delay',
  scheduling_delay_coach_side: 'Coach-side delay',
  hours_just_logged: 'Hours just logged',
  will_log_by_date: 'Will log by date',
  engagement_complete_should_close: 'Should close',
  client_unresponsive: 'Client unresponsive',
  needs_extension: 'Needs extension',
  paused_on_hold: 'Paused / on hold',
  billing_finance_question: 'Billing / finance',
  escalate_to_ariel: 'Escalate',
  no_action_fyi: 'FYI',
  ambiguous_needs_human: 'Ambiguous',
};

export function categoryLabel(category: string): string {
  return REPLY_CATEGORY_LABELS[category] ?? category;
}

/** Pill colors: warn (red) for attention buckets, navy for pending-verification. */
export function categoryPillStyle(category: string): { background: string; color: string } {
  const warn =
    category === 'ambiguous_needs_human' ||
    category === 'escalate_to_ariel' ||
    category === 'client_unresponsive';
  const verify = category === 'hours_just_logged' || category === 'will_log_by_date';
  return {
    background: warn ? 'rgba(184,67,10,0.12)' : verify ? 'rgba(45,106,158,0.12)' : 'rgba(46,125,50,0.12)',
    color: warn ? 'var(--warn)' : verify ? 'var(--navy)' : '#2e7d32',
  };
}
